import React, { Component, PropTypes } from 'react';
import { Form, Col, FormGroup, ControlLabel, FormControl, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import ProgressBar from '../components/progressBar/ProgressBar';
import config from '../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

export class ForgotPassword extends Component {
  static propTypes = {
    agentCode: PropTypes.string,
    email: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      agentCode: '',
      email: '',
      showModal: false,
      message: '',
      callSuccess: false,
      buttonDisabled: false,
      isLoading: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.validate = this.validate.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {}
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  handleChangeAgentCode(event) {
    this.setState({ agentCode: event.target.value });
  }

  handleChangeEmail(event) {
    this.setState({ email: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      buttonDisabled: true
    })
    if (this.validate()) {
      this.setState({ isLoading: true })
      axios.post(`${appUrlPath}/forgotPassword`, {
        agentCode: this.state.agentCode,
        email: this.state.email
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            message: 'Please check email for further instructions',
            showModal: true,
            callSuccess: true,
            buttonDisabled: false
          })
        } else {
          this.setState({
            message: res.data.errMsg,
            showModal: true,
            callSuccess: false,
            buttonDisabled: false
          });
        }
        this.setState({ isLoading: false })
      })
      .catch((err) => {
        if (err) {
          this.setState({
            message: err.response.data,
            showModal: true,
            callSuccess: false,
            buttonDisabled: false,
            isLoading: false
          });
        }
      });
    }
  }

  validate() {
    const agentCode = this.state.agentCode;
    const email = this.state.email;

    let valid = true;

    if (!agentCode || !email) {
      valid = false
      this.setState({
        message: 'Agent Code or email cannot be null.',
        showModal: true,
        buttonDisabled: false
      });
    }
    return valid;
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  close() {
    this.setState({ showModal: false }, () => {
      if (this.state.callSuccess) {
        window.location.assign('/en/motorb2b/login');
      }
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <Form horizontal onSubmit={this.handleSubmit}>
          <div className="EBaoHome__Container">
            <div className="ebaoUtil__Form">
              <h3 className="ForgotPassword__HeaderTwo">Forgot Password</h3>
              <ul className="ForgotPassword__Remarks">
                <li>We will help you sign in to AXA eServices. Please enter the details</li>
              </ul>
              <br /><br />
              <FormGroup controlId="">
                <Col componentClass={ControlLabel} sm={2}>
                  Username
                </Col>
                <Col sm={4}>
                  <FormControl type="text"
                    placeholder="Username"
                    value={this.state.agentCode}
                    onChange={this.handleChangeAgentCode}
                    autoComplete="off"
                    required
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={6}>
                  Enter agent code
                </Col>
              </FormGroup>
              <FormGroup controlId="">
                <Col componentClass={ControlLabel} sm={2}>
                  Email Address
                </Col>
                <Col sm={4}>
                  <FormControl type="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChangeEmail}
                    autoComplete="off"
                    required
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={6}>
                  Example: jsmith@axa-insurance.com.hk
                </Col>
              </FormGroup>
            </div>
            <br /><br />
           <FormGroup controlId="buttonGroup">
             <div className="ebaoUtil__ButtonGroup">
               <button type="submit" className="btn btn-axa" disabled={this.state.buttonDisabled}>Confirm</button>{' '}
               <button type="button" className="btn btn-axa" onClick={this.handleClick}>Back to Home</button>
             </div>
           </FormGroup>
          </div>
        </Form>
      </div>
    )
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/app/pages/ForgotPassword.js